import React from "react";

export default function Section({ id, title, className = "", children }) {
  return (
    <section id={id} className={`section ${className}`}>
      <div className="container">
        {title ? <h2>{title}</h2> : null}
        {children}
      </div>
    </section>
  );
}